import React from 'react';
import { observer } from 'mobx-react';
import './underConstruction.scss';
import { CollapseMenu } from '../../common/CollapseMenu/CollapseMenu';
import { mdiCrane } from '@mdi/js';
import Icon from '@mdi/react';

interface IUnderConstructionProps {
  tool?: 'design';
  activeDev?: boolean;
  title?: string;
}

const UnderConstructionComponent = (props: IUnderConstructionProps) => {
  // text to display indicating if the page is actively under development
  const textSets = {
    underConstruction: {
      title: 'Coming Soon',
      description: 'We are currently working on this feature and it will launch soon!'
    },
    futureDevelopment: {
      title: 'Future Development',
      description: 'Planned future features. Check back later.'
    }
  }
  // 
  switch (props.tool) {
    case 'design':
      // Meant to be used in collapse containers, like the design tools
      return (
        <div className="designelement-container">
          <CollapseMenu title={props.title!} cardBodyId="placeholder-design" noIcon={true} forceOpen={true}>
            <div className="alert-container alert-container-collapse">
              <Icon path={mdiCrane} size={4} />
              <div className="alert-title">
                <h1>{props.activeDev ? textSets.underConstruction.title : textSets.futureDevelopment.title}</h1>
              </div>
              <hr />
              <div className="alert-description">
                <p className="mb-1">{props.activeDev ? textSets.underConstruction.description : textSets.futureDevelopment.description}</p>
              </div>
            </div>
          </CollapseMenu>
        </div>
      );
    case undefined:
    default:
      // default full page message
      return (
        <div>
          <div className="alert-container">
            <Icon path={mdiCrane} size={4} />
            <div className="alert-title" tabIndex={0}>
              <h1>{props.activeDev ? textSets.underConstruction.title : textSets.futureDevelopment.title}</h1>
            </div>
            <hr />
            <div className="alert-description" tabIndex={0}>
              <p className="mb-1">{props.activeDev ? textSets.underConstruction.description : textSets.futureDevelopment.description}</p>
            </div>
          </div>
        </div>
      );
  }

};

export const UnderConstruction = observer(UnderConstructionComponent);
